import {IDomService} from './dom.service.interface';
import {EventListenerRegistration} from '../../../utils/event-listener-registration';


export class DomService implements IDomService {
  constructor() {
    this._eventListenerRegistration = new EventListenerRegistration(document);
  }

  disableScrolling(): void {
    this.body.classList.add('no-scrolling');
  }

  enableScrolling(): void {
    this.body.classList.remove('no-scrolling');
  }

  querySelector(selector: string): Element | null {
    return document.querySelector(selector);
  }

  get body(): HTMLElement {
    return document.body;
  }

  get head(): HTMLElement {
    return document.head;
  }

  get html(): HTMLElement {
      return document.documentElement;
  }

  setDocumentTitle(title: string): void {
    if(title) {
      document.title = title;
    }
  }

  get locationPathName(): string {
    return document.location.pathname;
  }

  private readonly _eventListenerRegistration;
  get subscribeTo(): EventListenerRegistration {
    return this._eventListenerRegistration;
  }

  getElementsByClassName(className: string): HTMLCollectionOf<Element> {
    return document.getElementsByClassName(className);
  }

  getElementsByTagName(tagName: string): HTMLCollectionOf<Element> {
    return document.getElementsByTagName(tagName);
  }

  getElementById(id: string): HTMLElement | null {
    return document.getElementById(id);
  }

  createElement(tagName: string): HTMLElement {
    return document.createElement(tagName);
  }
}
